import { SystemFuncArgs } from '$legacyecstatic';
import CarnivoreDoc from 'editor/components/CarnivoreDoc';
import { Components } from '../components';
import CarnivoreCtx from '../components/CarnivoreCtx';
import DOMOverlay from '../components/DOMOverlay';

export const configureDOMOverlayComponents = [
  DOMOverlay,
  CarnivoreCtx,
  CarnivoreDoc,
];

export function configureDOMOverlay(args: SystemFuncArgs<Components>): void {
  const { components } = args;
  const domOverlayComp = components.get(DOMOverlay);
  const { ctx: carnCtx } = components.get(CarnivoreCtx);
  const { doc: carnDoc } = components.get(CarnivoreDoc);

  // init the overlay.
  if (!domOverlayComp.domOverlay) {
    const domOverlay = carnCtx.createDOMOverlay({
      id: domOverlayComp.id,
      index: domOverlayComp.index,
    });

    if (!carnDoc) return;

    carnDoc.addDOMOverlay(domOverlay.id);

    domOverlayComp.domOverlay = domOverlay;

    // const c = domOverlay.getContainer();

    // const a = document.createElement('div');

    // a.style.setProperty('background-color', 'orange');
    // a.style.setProperty('height', '100px');
    // a.style.setProperty('width', '100px');
    // a.style.setProperty('position', 'absolute');

    // c.append(a);
  }
}
